document.addEventListener('DOMContentLoaded', async () => {
  const urlParams = new URLSearchParams(window.location.search);

  if (urlParams.get('custom-url') !== 'true') return;

  const parameterMappings = {
    anvendelse: 'glass-purpose',
    glastykkelse: 'glass-thickness',
    overfladebehandling: 'glass-coating',
    ekstravalg: 'extras',
    'solglas-type': 'sunglasses-type',
    farvevalg: null,
    recept: 'send-glasses-data-options',
    kvalitet: 'progressive-lenses'
  };

  const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

  const isInputVisible = (input$) => {
    const parent$ = input$.closest('.sunglasses-type-input, .transition-type-input');
    if (!parent$) return true;
    return !parent$.classList.contains('hidden');
  };

  const uncheckSiblings = (input$) => {
    const name = input$.getAttribute('name');
    if (!name) return;

    const siblings$ = document.querySelectorAll(`input[name="${name}"]`);
    siblings$.forEach((sibling$) => {
      sibling$.checked = false;
    });
  };

  const dispatchEvents = (input$) => {
    input$.dispatchEvent(new Event('change', { bubbles: true }));
    input$.dispatchEvent(new Event('click', { bubbles: true }));
  };

  const clickNextLabel = (input$) => {
    const label$ = input$.nextElementSibling;
    if (label$?.tagName === 'LABEL') {
      label$.click();
    }
  };

  const selectInput = (input$) => {
    if (!input$) return;

    uncheckSiblings(input$);
    input$.checked = true;
    clickNextLabel(input$);
    dispatchEvents(input$);
  };

  const processParameter = (key, value) => {
    if (key === 'custom-url') return;

    const matchingInputs$ = document.querySelectorAll(`input[custom-url-handle="${value}"]`);
    const expectedName = parameterMappings[key];

    matchingInputs$.forEach((input$) => {
      const inputName = input$.getAttribute('name');
      const shouldSelect = (expectedName && inputName === expectedName) || !expectedName || key === 'farvevalg';

      if (shouldSelect) {
        if (key === 'farvevalg' && !isInputVisible(input$)) return;
        selectInput(input$);
      }
    });
  };

  const orderedParams = [
    'anvendelse',
    'glastykkelse',
    'overfladebehandling',
    'kvalitet',
    'ekstravalg',
    'solglas-type',
    'farvevalg',
    'recept'
  ];

  for (const key of orderedParams) {
    const value = urlParams.get(key);
    if (value) {
      processParameter(key, value);
      await delay(150);
    }
  }
});
